<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp"> </p>
<section epub:type="frontmatter">
<p class="TNI">The author and publisher have provided this e-book to you for your personal use only. You may not make this e-book publicly available in any way. <b>Copyright infringement is against the law. If you believe the copy of this e-book you are reading infringes on the author’s copyright, please notify the publisher at: <a href="http://us.macmillanusa.com/piracy" target="_blank">us.macmillanusa.com/piracy</a>.</b></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyrightnotice.vue?75213c30